import React, { Component } from "react";
import { Row, Col, Card, Icon, Tag, Input, Radio, Select, message } from "antd";
import F from "../../../Functions";
import { Translate } from "react-translated";

const RadioGroup = Radio.Group;

class BFileStatusSelection extends Component {
  renderAssessmentCalculatorTitleAndDescription = () => {
    const { wizard } = this.props;

    return (
      <Card className="wizardBox center-align liabilityBox" type="inner">
        <h2>
          <Translate
            text={`Use the Intelligence Link to determine your proper limits of liability.`}
          />
        </h2>
        {wizard.status === "Renewal" ? (
          <div>
            { wizard.carrier == "Country Financial" && <div>
             <p>
             <Translate text={" (Client Name), the following questions aim to ensure we have all your insured assets listed correctly, at the current values, for your household protection. We do this to ensure that all of your asset values match up with the liability protection limits we have on your current policy. We understand that the current cost of everything has increased with inflation, and so have your asset values. These following questions will ensure that all your household assets are identified and that any replacement costs (including life insurance) have up-to-date values on your policy/ies. Let’s Begin!"} />
             </p>
            </div>}
          {wizard.carrier !== "Country Financial" && <div>
            <p>
              {'"'}
              <Translate
                text={`Here at our Agency we do things differently for your policy renewal. We are going to review your existing policy to make sure you qualify for all of our discounts and that your coverage satisfies your protection needs. We always start this conversation by reviewing your LIABILITY LIMITS.`}
              />
            </p>

            <p>
              <Translate
                text={`The correct liability limits protect your household against accidents, lawsuits, and catastrophes. I'll ask you a few questions using our agency's RISK ASSESSMENT CALCULATOR to identify any coverage gaps and make sure I don't miss any discounts.`}
              />
              {'"'}
            </p>
          </div>}
          </div>
        ) : (
          <div>
            <p>
              <Translate
                text={`Liability limits on your policy are crucial to making sure your household is properly protected against accidents, lawsuits, and catastrophes. We do things differently at our agency & use a calculator that will suggest liability limits YOU NEED on your policy(ies). These next set of questions will help us determine whether any coverage gaps exist.`}
              />
            </p>
          </div>
        )}
      </Card>
    );
  };
  render() {
    const { wizard, updateField } = this.props;

    return (
      <div>
        <Card
          className="wizardBox center-align"
          type="inner"
          style={{ padding: 10 }}
        >
          <RadioGroup
            value={wizard.status}
            onChange={(e) => updateField("status", e.target.value)}
          >
            <Radio className="btnYes" value="Renewal">
              <Icon type="sync" style={{ marginRight: 10 }} />{" "}
              <Translate text={`Existing Customer`} />
            </Radio>
            <Radio className="btnYes" value="New B File">
              <Icon type="user-add" style={{ marginRight: 10 }} />{" "}
              <Translate text={`New Customer`} />
            </Radio>
          </RadioGroup>
        </Card>
        {"bfileType" in window.localStorage &&
        (window.localStorage.bfileType === "new" ||
          (window.localStorage.bfileType === "quick" &&
            wizard.rac_calculator > 0))
          ? this.renderAssessmentCalculatorTitleAndDescription()
          : null}
      </div>
    );
  }
}

export default BFileStatusSelection;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/bfile-status-selection.js